import React, { useEffect } from 'react';
import { isBlank } from 'utils/helperMethods';
import { head } from 'ramda';
import PropTypes from 'prop-types';
// import { useTranslation } from 'react-i18next';
import { formatMoneyWithSign } from 'utils/currencyHelper';

import { Box, Typography, Button } from '@material-ui/core';
import MortgageSurveyQuestionPresenter from 'presenters/MortgageSurveyQuestionPresenter';
// import InputWithSlider from 'sharedComponents/InputWithSlider';
import MortgageSurveyPresenter from 'presenters/MortgageSurveyPresenter';

import useStyles from './useStyles';

// /** The default price target percentage */
// const PRICE_TARGET_RATIO = 10 / 100;
// /** The maximum suggested downpayment for the price target */
// const MAX_VALUE_RATIO_FROM_PRICE_TARGET = 30 / 100;
// /** The minimum suggested downpayment for price target, trigger warning */
// const MIN_VALUE_RATIO_FROM_PRICE_TARGET = 3 / 100;

const DownPaymentTargetQuestion = props => {
  const { question, onChange, surveyValues, onValidate, onNext } = props;
  // const { t } = useTranslation();
  const classes = useStyles();

  const field = head(MortgageSurveyQuestionPresenter.surveyValueFields(question));
  const currentValue = MortgageSurveyPresenter[field](surveyValues);
  // const options = MortgageSurveyQuestionPresenter.options(question);
  // const { min, marksDivider } = options;
  const priceTarget = MortgageSurveyPresenter.priceTarget(surveyValues);
  const dp35 = Math.round(priceTarget * 0.035);
  const dp5 = Math.round(priceTarget * 0.05);
  const dp10 = Math.round(priceTarget * 0.1);
  const dp20 = Math.round(priceTarget * 0.2);
  // const max = priceTarget * MAX_VALUE_RATIO_FROM_PRICE_TARGET;

  useEffect(() => {
    const isValueValid = !isBlank(currentValue) && currentValue < priceTarget && currentValue >= 0;
    onValidate(isValueValid);
  }, [currentValue]);

  // useEffect(() => {
  //   if (!initialPassing) return;
  //   onChange([{ field, value: priceTarget * PRICE_TARGET_RATIO }]);
  // }, []);

  // const normalizedValue = typeof currentValue === 'number' ? currentValue : 0;
  // const shouldShowLessWarning = normalizedValue / priceTarget < MIN_VALUE_RATIO_FROM_PRICE_TARGET;
  // const shouldShowMoreWarning = currentValue >= priceTarget;

  const handleValueChange = value => {
    onChange([{ field, value }]);
  };

  const onSelectNext = value => {
    handleValueChange(value);
    onNext();
  };

  return (
    <Box width="100%">
      <Typography variant="h1">{MortgageSurveyQuestionPresenter.label(question)}</Typography>
      <Box mt={2} />
      <Typography variant="body1">{MortgageSurveyQuestionPresenter.description(question)}</Typography>
      <Box mt={4} />
      <Box display="flex" maxWidth="900px" width="100%" my={3} flexWrap="wrap" justifyContent="center">
        <Button onClick={() => onSelectNext(dp35)} className={classes.button} variant="contained">
          {`${formatMoneyWithSign(dp35, 'USD')} (3.5%)`}
        </Button>
        <Button onClick={() => onSelectNext(dp5)} className={classes.button} variant="contained">
          {`${formatMoneyWithSign(dp5, 'USD')} (5%)`}
        </Button>
        <Button onClick={() => onSelectNext(dp10)} className={classes.button} variant="contained">
          {`${formatMoneyWithSign(dp10, 'USD')} (10%)`}
        </Button>
        <Button onClick={() => onSelectNext(dp20)} className={classes.button} variant="contained">
          {`${formatMoneyWithSign(dp20, 'USD')} (20%)`}
        </Button>
        {/* <InputWithSlider
        className={classes.input}
        value={currentValue}
        min={min}
        max={max}
        marksDivider={marksDivider}
        label={MortgageSurveyQuestionPresenter.inputLabel(question)}
        onChange={handleValueChange}
      />
      <Box width="100%" className={classes.buttonBox}>
        <Button onClick={onNext} className={classes.button} variant="contained" disabled={!isValid}>
          {t('components.MortgageSurvey.ControlBar.nextButton')}
        </Button>
      </Box>
      {shouldShowLessWarning && (
        <Box width="100%" className={classes.warning} mt={1} p={2}>
          <Typography variant="body1" color="inherit" className={classes.warningHeader}>
            {t('components.MortgageSurvey.DownPaymentTargetQuestion.warning')}
          </Typography>
          <Box mt={2} />
          <Box
            className={classes.warningText}
            dangerouslySetInnerHTML={{ __html: t('components.MortgageSurvey.DownPaymentTargetQuestion.lessWarning') }}
          />
        </Box>
      )}
      {shouldShowMoreWarning && (
        <Box width="100%" className={classes.warning} mt={1} p={2}>
          <Typography variant="body1" color="inherit" className={classes.warningHeader}>
            {t('components.MortgageSurvey.DownPaymentTargetQuestion.warning')}
          </Typography>
          <Box mt={2} />
          <Typography variant="body2">
            {t('components.MortgageSurvey.DownPaymentTargetQuestion.moreWarning')}
          </Typography>
        </Box>
      )} */}
      </Box>
    </Box>
  );
};

DownPaymentTargetQuestion.propTypes = {
  question: MortgageSurveyQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  surveyValues: MortgageSurveyPresenter.shape().isRequired,
  onValidate: PropTypes.func.isRequired,
  // initialPassing: PropTypes.bool.isRequired,
};

export default DownPaymentTargetQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurvey/components/DownPaymentTargetQuestion/DownPaymentTargetQuestion.js